import { Injectable, EventEmitter } from '@angular/core';

@Injectable()
export class CampCareBookingsCalendarEventService {

    public refreshCalendar$: EventEmitter<any> = new EventEmitter<boolean>();

    constructor() { }

    public onRefreshCalendar():void{
        this.refreshCalendar$.emit(null);
    }
}
